import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button, Col, ModalHeader, ModalBody, ModalFooter,
    Row, Card, CardBody
} from 'reactstrap';

import withAuth from '../../../components/Services/WithAuth';
import './style.css';
import SectionTemplateForm from './SectionTemplateForm/index';
import { setSectionTemplateData, setSectionTemplateFile, setSectionTemplateEditData, setSectionTemplateMapping, setSectionTemplateMappingEdit, getMasterDataValue, updateAPIKeyNameRequest } from './action';
import { getSectionTemplateDetails, fetchSectionTemplateSuccess } from '../View/action';
import { sectionTemplateSaveBody, validateSectionTemplateForm, sectionTemplateEditBody, getTableFlagValue, setMappingData, setMasterDataValues, checkSectionTemplateFetchData, setRequestMappingData, updateMappingData } from './helper';
import ModalComponent from '../../../components/ReusableComponents/ModalComponent/index';
import Modal from '../../../components/UI/Modal/Modal';
import { FINANCIAL, CREATE, OBJECT_LIST, SYSTEMDEFINED, CREATED, EDITED, DATA,VIDEO_KYC, SIMPLE, INTERNATIONAL, LIST_OF_VERTICAL_KEY_VALUE, VERTICAL_LIST } from '../constants';
import { Preloading } from '../../../components/UI/Preloader/action';
import SectionTemplateTableView from './TableView/index';
import { toast } from 'react-toastify';
class CreateSectionTemplateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileName: null,
            file: null,
            validateMessage: null,
            validationFlag: true,
            sectionTemplateinitialValues: {
                sectionTemplateName: '',
                reportDisplayName: '',
                keys: OBJECT_LIST,
                sectionType: SYSTEMDEFINED,
                apiKeyName :'',
                tags : '',
                analystVisible: false
            },
            sectionTemplateId: null,
            sectionTemplateViewLink: '',
            viewEditFlag: true,
            downloadButton: null,
            pageType: 'Create',
            showModal: false,
            body: null,
            modalClass: 'Modal',
            sectionTemplateTableFlag: false,
            mappingData: [],
            mappingRequestData: [],
            masterDataValues: [],
            tableModalFlag: false,
            fileFlag: false,
            apiKeyFlag : false
        }
    }
    handleUpload = (event) => {
        this.setState({
            fileName: event.target.files[0].name
        })
        this.props.setSectionTemplateFile(event.target.files[0]);
        event.target.value = null
    }
    componentDidMount() {
        this.setState({
            sectionTemplateId: this.props.match.params.sectionTemplateId,
        }, () => {
            if (this.state.sectionTemplateId) {
                this.props.preloading(true)
                this.setState({
                    pageType: 'Edit',
                    sectionTemplateViewLink: '/sectiontemplate/view/' + this.state.sectionTemplateId
                })
                this.props.getSectionTemplateDetails(this.state.sectionTemplateId);
            } else {
                this.setState({
                    pageType: 'Create',
                    sectionTemplateViewLink: '/sectiontemplate/search'
                })
            }

        })
    }

    componentDidUpdate(prevProps) {
        const { masterDataValues, masterDataValuesFailure, mappingFetchSuccess, mappingFetchFailure, mappingEditSuccess, mappingEditFailure, sectionTemplateFetchDetails, sectionTemplateFormData, sectionTemplateFile, sectionTemplateSuccess, sectionTemplateError } = this.props;
        if(prevProps.apiKeyNameResponse !== this.props.apiKeyNameResponse){
            this.props.preloading(false);
            if(this.props.apiKeyNameResponse && this.props.apiKeyNameResponse.status == "SUCCESS"){
                toast.success(
                    <div>
                        {this.props.apiKeyNameResponse.message}
                    </div>
                );
            }else{
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp; Something went wrong, Please try again !!
                    </div>
                );
            }
        }
        
        if (mappingFetchSuccess !== prevProps.mappingFetchSuccess) {
            const tempMappingData = setMappingData(mappingFetchSuccess);
            this.setState({
                mappingData: tempMappingData,
                tableModalFlag: true,
                mappingRequestData: mappingFetchSuccess
            }, () => {
                if (sectionTemplateFormData.values.sectionType === FINANCIAL) {
                    this.props.getMasterDataValue(FINANCIAL)
                } else if (sectionTemplateFormData.values.sectionType === DATA && sectionTemplateFormData.values.keys === OBJECT_LIST) {
                    this.props.getMasterDataValue(OBJECT_LIST)
                }else if(sectionTemplateFormData.values.sectionType === DATA && sectionTemplateFormData.values.keys === LIST_OF_VERTICAL_KEY_VALUE) {
                    this.props.getMasterDataValue(VERTICAL_LIST);
                }else if (sectionTemplateFormData.values.sectionType === DATA) {
                    this.props.getMasterDataValue(SIMPLE)
                }else if (sectionTemplateFormData.values.sectionType === VIDEO_KYC) {
                    this.props.getMasterDataValue(SIMPLE)
                }
                
            })
        }
        if (mappingFetchFailure !== prevProps.mappingFetchFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.mappingFetchFailure.data.message}
                </div>
            );
        }
        if (mappingEditSuccess !== prevProps.mappingEditSuccess) {
            this.setState((prevState) => ({
                showModal: !prevState.showModal,
                body: null
            }))
            toast.success(
                <div>
                    {this.props.mappingEditSuccess.message}
                </div>
            );

            const flag = checkSectionTemplateFetchData(sectionTemplateFetchDetails.data);
            if (flag) {
                this.props.setSectionTemplateMapping([sectionTemplateFetchDetails.data.id])
            }
        }
        if (mappingEditFailure !== prevProps.mappingEditFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.mappingEditFailure.data.message}
                </div>
            );
        }
        if (masterDataValues !== prevProps.masterDataValues) {
            const tempData = setMasterDataValues(this.state.mappingData, masterDataValues)
            this.setState({
                masterDataValues: masterDataValues,
                mappingData: tempData
            })
        }
        if (masterDataValuesFailure !== prevProps.masterDataValuesFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.masterDataValuesFailure.data.message}
                </div>
            );
        }
        if (this.props.sectionTemplateType !== prevProps.sectionTemplateType) {
            if (this.props.sectionTemplateType === CREATE) {
                this.props.fetchSectionTemplateSuccess([]);
            }
            this.setState({
                pageType: this.props.sectionTemplateType
            })
        }
        if (sectionTemplateFormData !== prevProps.sectionTemplateFormData || sectionTemplateFile !== prevProps.sectionTemplateFile) {
            const tempTableFlag = getTableFlagValue(this.state.pageType, sectionTemplateFormData.values)
            if (validateSectionTemplateForm(sectionTemplateFormData.values, sectionTemplateFile)) {
                this.setState({ validationFlag: false, sectionTemplateTableFlag: tempTableFlag });
            } else {
                this.setState({ validationFlag: true, sectionTemplateTableFlag: tempTableFlag });
            }
            const tempPrevSectionValues = (prevProps.sectionTemplateFormData) ? prevProps.sectionTemplateFormData.values.sectionType : '';
            const tempPrevKeyValue = (prevProps.sectionTemplateFormData) ? prevProps.sectionTemplateFormData.values.keys : '';
            if (sectionTemplateFormData.values.sectionType !== tempPrevSectionValues || sectionTemplateFormData.values.keys !== tempPrevKeyValue) {
                if (sectionTemplateFetchDetails && sectionTemplateFetchDetails.data) {
                    let flag;
                    if (sectionTemplateFetchDetails.data.sectionDataTableType !== sectionTemplateFormData.values.keys || sectionTemplateFetchDetails.data.sectionType !== sectionTemplateFormData.values.sectionType) {
                        flag = false
                    } else {
                        flag = true
                    }
                    this.setState({
                        tableModalFlag: (checkSectionTemplateFetchData(sectionTemplateFetchDetails.data)) ? flag : false
                    })
                }
            }
        }
        if (sectionTemplateFetchDetails !== prevProps.sectionTemplateFetchDetails) {
            if (this.props.match.params.sectionTemplateId) {
                this.props.preloading(false)
                const tempTableFlag = getTableFlagValue(this.state.pageType, sectionTemplateFetchDetails.data)
                if( sectionTemplateFetchDetails.data.tags !== null){
                    const tagValue = sectionTemplateFetchDetails.data.tags.filter(Boolean).join(",")    
                    this.setState({
                        sectionTemplateinitialValues: {
                            sectionTemplateName: sectionTemplateFetchDetails.data.displayName,
                            reportDisplayName: sectionTemplateFetchDetails.data.reportDisplayName,
                            keys: sectionTemplateFetchDetails.data.sectionDataTableType,
                            sectionType: sectionTemplateFetchDetails.data.sectionType,
                            apiKeyName: sectionTemplateFetchDetails.data.apiKeyName,
                            tags : tagValue,
                            analystVisible: sectionTemplateFetchDetails.data.analystVisible
                        },
                        sectionTemplateTableFlag: tempTableFlag,
                        tableModalFlag: false
                    }, () => {
                        const flag = checkSectionTemplateFetchData(sectionTemplateFetchDetails.data);
                        if (flag) {
                            this.props.setSectionTemplateMapping([sectionTemplateFetchDetails.data.id])
                        }
                    });
                }else{
                    this.setState({
                        sectionTemplateinitialValues: {
                            sectionTemplateName: sectionTemplateFetchDetails.data.displayName,
                            reportDisplayName: sectionTemplateFetchDetails.data.reportDisplayName,
                            keys: sectionTemplateFetchDetails.data.sectionDataTableType,
                            sectionType: sectionTemplateFetchDetails.data.sectionType,
                            apiKeyName: sectionTemplateFetchDetails.data.apiKeyName,
                            analystVisible: sectionTemplateFetchDetails.data.analystVisible
                        },
                        sectionTemplateTableFlag: tempTableFlag,
                        tableModalFlag: false
                    }, () => {
                        const flag = checkSectionTemplateFetchData(sectionTemplateFetchDetails.data);
                        if (flag) {
                            this.props.setSectionTemplateMapping([sectionTemplateFetchDetails.data.id])
                        }
                    });
                }

            } else {
                this.setState({
                    sectionTemplateinitialValues: {
                        sectionTemplateName: '',
                        reportDisplayName: '',
                        keys: OBJECT_LIST,
                        sectionType: SYSTEMDEFINED,
                        apiKeyName : '',
                        analystVisible: false
                    }
                });
            }
        }
        if (sectionTemplateSuccess !== prevProps.sectionTemplateSuccess) {
            let actionType, viewUrl;
            if (sectionTemplateFormData.values.sectionType === FINANCIAL) {
                viewUrl = `/sectiontemplate/view/${sectionTemplateSuccess.data[0].id}`
            } else {
                viewUrl = `/sectiontemplate/view/${sectionTemplateSuccess.data.id}`
            }
            if (this.state.sectionTemplateId) {
                actionType = EDITED;
                this.setState({
                    tableModalFlag: true
                })
            } else {
                actionType = CREATED
            }
            this.props.preloading(false)
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;Section Template {actionType} Successfully</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                        <Button color="primary" onClick={() => this.redirectView(viewUrl)}>View changes</Button>
                    </ModalFooter>
                </div>,
                modalClass: 'Modal'
            }))
        } else if (sectionTemplateError !== prevProps.sectionTemplateError) {
            this.props.preloading(false)
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Error</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{sectionTemplateError.data.response.data.message}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </div>,
                modalClass: 'Modal'
            }))
        }
    }
    redirectView = (viewUrl) => {
        this.props.history.push(viewUrl);
    }
    close = () => {
        this.setState(prevState =>
            ({
                showModal: !prevState.showModal,
                body: null
            }));

    }
    handleFormChange = (key, value) => {
        let temp = this.state.sectionTemplateinitialValues;
        temp[key] = value;
        this.setState({
            sectionTemplateinitialValues: temp
        })
    }

    handleSave = () => {
        const { sectionTemplateFile } = this.props
        const sectionTemplateFormData = this.props.sectionTemplateFormData.values
        this.props.preloading(true)
        if (this.state.sectionTemplateId) {
            this.props.setSectionTemplateEditData(sectionTemplateEditBody(sectionTemplateFormData, this.state.sectionTemplateId, sectionTemplateFile));
        } else {
            this.props.setSectionTemplateData(sectionTemplateSaveBody(sectionTemplateFormData, sectionTemplateFile));
        }
        this.props.setSectionTemplateFile(null)
    }

    saveAPIKeyName = (e) => {
        e.preventDefault();
        this.props.preloading(true);
        this.props.updateAPIKeyNameRequest({ sectionTemplateId : this.state.sectionTemplateId, apiKeyName: this.props.sectionTemplateFormData.values.apiKeyName});
    }
    handleCancel = () => {
        this.props.history.push('/sectiontemplate/search');
    }
    
    handleTableDataChange = (data) => {
        const mappingRequestData = setRequestMappingData(this.state.mappingRequestData, data)
        const mappingData = updateMappingData(this.state.mappingData, data);
        this.setState({
            mappingData: mappingData,
            mappingRequestData: mappingRequestData
        })

    }
    handleSubmit = (e, type) => {
        e.preventDefault();
        let data = { type: type, mappingObject: this.state.mappingRequestData };
        this.props.setSectionTemplateMappingEdit(data);
    }

    handleTableView = (flag) => {
        this.setState((prevState) => ({
            apiKeyFlag :  (flag) ? !prevState.showModal : prevState.showModal,
            showModal: (flag) ? !prevState.showModal : prevState.showModal,
           
            modalClass: 'Large-Modal data-mapping-modal'
        }))

    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <Row className="d-flex justify-content-between align-items-center mb-3">
                            <Col sm='20'>
                                <h4 className="mb-0">
                                    {this.state.pageType} Section Template
                            </h4>
                            </Col>
                            <Col sm='4'>
                                <Button color='primary' disabled={!this.state.tableModalFlag} className='btn table-modal-button' onClick={() => this.handleTableView(true)}>Data Mapping</Button>
                            </Col>
                        </Row>
                        <Card>
                            <CardBody>
                                <SectionTemplateForm pageType = {this.state.pageType} viewEditFlag={this.state.viewEditFlag} initialValues={this.state.sectionTemplateinitialValues} />
                                <div className="row form-group">
                                    <div className="col-sm-5">
                                        <label>Section Template File</label>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="row btn-group sectiontemplate-filename" role="group" aria-label="Section Template Upload">

                                            {/* <input type="file" className="section-template-upload" name="sectionTemplate" id="sectionTemplate" onChange={this.handleUpload} accept=".xlsx" /> */}
                                            <div className="btn btn-secondary position-relative ml-4">
                                                <input type="file" name="sectionTemplate" id="sectionTemplate" onChange={this.handleUpload} accept=".xlsx" className="upload-file" />
                                                Choose File
                                            </div>
                                            <span className="mt-2 ml-3">{this.state.fileName}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <Col sm="15">
                                        {this.state.validateMessage}
                                    </Col>
                                </div>
                                <Row>
                                    <Col sm="15" className="text-right">
                                        <Button title="Cancel" outline onClick={this.handleCancel} color="primary">Cancel</Button>
                                        <Button disabled={this.state.validationFlag} title="Save" onClick={this.handleSave} color="primary" className="ml-3">Save</Button>
                                        <Button disabled={!(this.props.sectionTemplateFormData && this.props.sectionTemplateFormData.values && this.props.sectionTemplateFormData.values.apiKeyName)} title="Save" onClick={e => this.saveAPIKeyName (e)} color="primary" className="ml-3">Save API Name</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <ModalComponent {...this.props} />
                    </Col>
                </Row>
                <Modal show={this.state.showModal} className={this.state.modalClass} modalClosed={this.handleAdd || this.onCancel} >
                    {/* <p>Show Modal Data</p> */}
                    {this.state.apiKeyFlag ? <div>
                   <ModalHeader>Data Mapping</ModalHeader>
                    <ModalBody className='mapping-table-modal-body'>
                        < Card >
                            <CardBody>
                                <SectionTemplateTableView pageType = {this.state.pageType} tableCallback={this.handleTableDataChange} mappingData={this.state.mappingData} />
                            </CardBody>
                        </Card>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                        <Button color="primary" onClick={(e)=> this.handleSubmit(e, "MASTER_KEY")}>Save Master Keys</Button>
                        {this.state.pageType == "Edit" &&<Button color="primary" onClick={(e)=> this.handleSubmit(e, "API_KEY")} disabled = {true}>Save API Keys</Button>}
                    </ModalFooter>
                </div> : this.state.body}
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    sectionTemplateFormData: state.form.sectionTemplate,
    sectionTemplateFile: state.sectionTemplate.sectionTemplateFile,
    selectedSectionTemplateId: state.sectionTemplateSearch.sectionTemplateSearchData,
    sectionTemplateFetchDetails: state.sectionTemplateDetails.sectionTemplateDetails,
    sectionTemplateSuccess: state.sectionTemplate.sectionTemplateSuccess,
    sectionTemplateError: state.sectionTemplate.sectionTemplateError,
    mappingFetchSuccess: state.sectionTemplate.mappingSuccess,
    mappingFetchFailure: state.sectionTemplate.mappingFailure,
    mappingEditSuccess: state.sectionTemplate.mappingEdit,
    mappingEditFailure: state.sectionTemplate.mappingEditFailure,
    masterDataValues: state.sectionTemplate.masterDataValues,
    masterDataValuesFailure: state.sectionTemplate.masterDataValuesFailure,
    apiKeyNameResponse : state.sectionTemplate.apiKeyNameResponse
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    setSectionTemplateData: (sectionTemplateData) => { dispatch(setSectionTemplateData(sectionTemplateData)) },
    setSectionTemplateEditData: (sectionTemplateData) => { dispatch(setSectionTemplateEditData(sectionTemplateData)) },
    setSectionTemplateFile: (file) => { dispatch(setSectionTemplateFile(file)) },
    getSectionTemplateDetails: (data) => { dispatch(getSectionTemplateDetails(data)) },
    fetchSectionTemplateSuccess: (data) => { dispatch(fetchSectionTemplateSuccess(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    setSectionTemplateMapping: (data) => { dispatch(setSectionTemplateMapping(data)) },
    setSectionTemplateMappingEdit: (data) => { dispatch(setSectionTemplateMappingEdit(data)) },
    getMasterDataValue: (data) => { dispatch(getMasterDataValue(data)) },
    updateAPIKeyNameRequest : (data) => {dispatch(updateAPIKeyNameRequest(data))}
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(CreateSectionTemplateComponent));
